<div class="headerdiv">
    <div >
      <h3 class="pagetitle">Admin Management</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>
  
  <mat-card [formGroup]="adminsForm" class="addadmin">
  <div class="row">
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input formControlName="first_name" matInput placeholder="First Name">
          </mat-form-field>
      </div>
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input formControlName="last_name" matInput placeholder="Last Name">
          </mat-form-field>
      </div>
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input formControlName="email" matInput placeholder="Email">
          </mat-form-field>
      </div>
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input formControlName="password" matInput placeholder="Password">
          </mat-form-field>
      </div>
      <div class="col d-flex justify-content-center">
      <mat-form-field appearance="outline">
        <mat-label>Select</mat-label>
        <mat-select formControlName="user_type">
          <mat-option value="2">Admin</mat-option>
          <mat-option value="1">Super Admin</mat-option>

        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <button (click)="submitForm()" mat-flat-button color="primary">Add Admin</button>
</mat-card>



<div style="font-size: 10px" class="container tablecontainer">
  <div class="row">

    <div class="search">
      <label for="search">Search for Admin</label>

      <div class="md-form">
        <input style="border: 1px solid #5d2041;"
          type="text"
          [(ngModel)]="searchText"
          class="form-control"
          id="search"
          mdbInput
        />
      </div>
    </div>
  </div>

  <table mdbTable #adminsTable="mdbTable" class="z-depth-1">
    <thead style="background-color: #5d2041; color: white;">
      <tr>
        <th
          *ngFor="let head of headElements; let i = index"
          aria-controls="tableSortExample" 
          scope="col" 
          [mdbTableSort]="adminsList" 
          [sortBy]="headElements[i]"
        >
          {{head | titlecase}}
        </th>
        
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let el of adminsList; let i = index">
        <th *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex"
          scope="row">{{adminsList[i].first_name +" "+ adminsList[i].last_name}}</th>
          
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{adminsList[i].email}}</td>
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{adminsList[i].user_type}}</td>
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex"><button mat-raised-button (click)="deactivateAdmin(adminsList[i].id)">Deactivate</button>
          <!-- <button mat-raised-button style="margin-left: 5px;">Reset Password</button> -->
        </td>
      </tr>
        <td colspan="4">
          <mdb-table-pagination [tableEl]="adminsTable" [searchDataSource]="adminsList"></mdb-table-pagination>
        </td>
    </tbody>
  </table>
</div>